export default __webpack_public_path__ + "static/Inter-Medium-18b8c68e64126db9ce88dfcf10b6ac84.ttf";